import React from "react";
import { useFetch } from "../lib/api";
import { SectionLabel } from "../components/shared";
import { Radio, CalendarDays, PlayCircle } from "lucide-react";

const tagColors = { SEC: "#3F4CE0", CISA: "#E5484D", FinCEN: "#E8590C", Fed: "#0E9355", NIST: "#3F4CE0", States: "#B45309" };

export default function Pulse() {
  const { data: pulseFeed } = useFetch("/pulse");
  const { data: adminWebinars } = useFetch("/webinars");
  return (
    <main className="max-w-[1320px] mx-auto px-5 lg:px-8 py-14" data-testid="pulse-page">
      <SectionLabel color="#12B76A">Pulse · live risk intelligence</SectionLabel>
      <h1 className="font-display font-bold text-[38px] lg:text-[54px] tracking-tight">This week in <span className="text-[#12B76A]">American risk.</span></h1>
      <p className="mt-4 text-[16px] text-[#1A1914]/60 max-w-2xl">Curated regulatory and threat intel — refreshed daily, summarized for busy risk teams.</p>
      <div className="mt-10 grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-3" data-testid="pulse-feed">
          {(pulseFeed || []).map((p, i) => (
            <div key={i} className="rp-card bg-white border border-[#E7E0D2] rounded-2xl p-5 flex gap-4">
              <div className="w-10 h-10 shrink-0 rounded-xl flex items-center justify-center" style={{ background: `${tagColors[p.tag]}12`, color: tagColors[p.tag] }}><Radio size={17} /></div>
              <div>
                <div className="flex items-center gap-2.5">
                  <span className="font-mono-label text-[10px] font-semibold" style={{ color: tagColors[p.tag] }}>{p.tag}</span>
                  <span className="text-[11.5px] text-[#1A1914]/40">{p.time}</span>
                </div>
                <h3 className="mt-1.5 font-semibold text-[16px] leading-snug">{p.title}</h3>
                <p className="mt-1 text-[13.5px] text-[#1A1914]/60 leading-relaxed">{p.summary}</p>
              </div>
            </div>
          ))}
        </div>
        <aside className="space-y-4">
          <div className="bg-[#14130F] text-white rounded-2xl p-6">
            <p className="font-mono-label text-[10px] text-white/40 flex items-center gap-1.5"><CalendarDays size={12} /> US Risk Desk · webinars</p>
            <div className="mt-4 space-y-4">
              {(adminWebinars || []).map((w) => (
                <div key={w.id} className="pb-4 border-b border-white/10 last:border-0 last:pb-0">
                  <p className="text-[14px] font-semibold leading-snug">{w.title}</p>
                  <p className="mt-1 text-[12px] text-white/50">{w.guest} · {w.date}</p>
                  <p className="mt-1.5 text-[12px] text-[#12B76A] inline-flex items-center gap-1"><PlayCircle size={12} /> {w.status} · {w.registrations} registered</p>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white border border-[#E7E0D2] rounded-2xl p-6">
            <p className="font-mono-label text-[10px] text-[#1A1914]/40">RiskPedia Shorts · 60s</p>
            <p className="mt-2 text-[14px] text-[#1A1914]/65 leading-relaxed">Bite-sized explainers on every US obligation — five active series, new Shorts weekly. Video library ships with the full release.</p>
          </div>
        </aside>
      </div>
    </main>
  );
}
